(function () {
    "use strict";

    var controllerId = "licenzaAdd";
    angular.module('app').controller(controllerId, ["$scope", "$rootScope", "$filter", "$uibModalInstance", "datacontext", "common", '$translate', licenzaAdd]);

    function licenzaAdd($scope, $rootScope, $filter, $uibModalInstance, datacontext, common, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');

        $scope.item = {};
        $scope.item.strumF = "P";
        $scope.item.verificato = false;
        $scope.item.loading = false;
        $scope.item.titolo = "AcquistaLicenzaIl";
        if ($rootScope.licenza)
            $scope.item.titolo = "RinnovaLicenza";
        caricaRiepilogo();
        getBonifico();

        $scope.ok = function (isValid) {
            if (isValid) {
                var item = {};
                item.strumF = $scope.item.strumF;
                $uibModalInstance.close(item);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.verificaCodice = function () {
            $scope.item.loading = true;
            $scope.item.voucherError = "";
            $scope.item.error = false;
            $scope.item.verificato = false;

            datacontext.cartaDocente_check($scope.item.codiceVoucher)
                .then(function (data) {
                    if (data.server_status) {
                        if (data.server_status == '200') {
                            //Proxy php OK
                            $scope.item.voucher = data.data[0].checkResp;

                            var importoVoucher = parseFloat($scope.item.voucher.importo);
                            var importoPrevisto = $scope.importo;
                            if (!importoPrevisto || !importoVoucher || importoPrevisto > importoVoucher) {
                                $scope.item.voucherError = $translate.instant('ImportoVoucher');
                                $scope.item.error = true;
                                $scope.item.loading = false;
                                return;
                            }
                            else
                                $scope.item.verificato = true;
                        }
                        else {
                            //Errore proxy php                            
                            $scope.item.voucherError = data && data.data[0] && data.data[0].FaultVoucher && data.data[0].FaultVoucher.exceptionMessage ? data.data[0].FaultVoucher.exceptionMessage : 'Servizio carta del docente non raggiungibile';
                            $scope.item.error = true;                            
                        }
                    }
                    else {
                        //Errore server api                        
                        $scope.item.voucherError = data;
                        $scope.item.error = true;
                    }
                })
                .finally(function () {
                    $scope.item.loading = false;
                });
        };

        $scope.conferma = function (isValid) {
            if (isValid) {
                $scope.item.loading = true;
                $scope.item.voucherError = "";
                $scope.item.error = false;

                var importoVoucher = parseFloat($scope.item.voucher.importo);
                var importoPrevisto = $scope.importo;

                if (!importoPrevisto || !importoVoucher || importoPrevisto > importoVoucher)
                {
                    $scope.item.voucherError = $translate.instant('ImportoVoucher');
                    $scope.item.error = true;
                    $scope.item.loading = false;
                    return;
                }

                datacontext.cartaDocente_confirmLicenza($scope.item.codiceVoucher, $scope.item.voucher.nominativoBeneficiario).then(function (data) {
                        if (data.server_status) {
                            if (data.server_status == '200') {
                                //Proxy php OK                                
                                var item = {};
                                item.strumF = $scope.item.strumF;
                                $uibModalInstance.close(item);
                            }
                            else {
                                //Errore proxy php                            
                                $scope.item.voucherError = data && data.data[0] && data.data[0].FaultVoucher && data.data[0].FaultVoucher.exceptionMessage ? data.data[0].FaultVoucher.exceptionMessage : 'Servizio carta del docente non raggiungibile';
                                $scope.item.error = true;
                            }
                        }
                        else {
                            //Errore server api                        
                            $scope.item.voucherError = data;
                            $scope.item.error = true;
                        }
                    })
                .finally(function () {
                    $scope.item.loading = false;
                });                
            }
        };

        function caricaRiepilogo() {
            $scope.item.riepilogo = "";
            datacontext.ordine_calcola().then(function (data) {
                $scope.importo = parseFloat(data.Totale);
                $scope.item.riepilogo = $translate.instant('TotaleDovuto') + $filter("currency")(data.Totale) + $translate.instant('NuovaLicenza') + $filter("date")(data.DataFineLicenza, "dd/MM/yyyy") + ".";
            });
        }

        function getBonifico() {
            return datacontext.contoCorrente_getAll().then(function (items) {
                return $scope.item.bonifico = items[0];
            });
        }
    }
})();